import { CentrifugoChatClient } from './centrifugo-client';
import { ChatRealtimeClient } from './types';

export const createChatRealtimeClient = (): ChatRealtimeClient => new CentrifugoChatClient();
